import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export function saveBlob(blob, name) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export async function fetchFile(method, path, body) {
  const r = await api.request({ method, url: path, data: body, responseType: "blob" });
  const name = /filename="([^"]+)"/.exec(r.headers["content-disposition"] || "")?.[1] || "dentaflow.pdf";
  return { blob: r.data, name };
}

async function readError(e) {
  if (e?.response?.data instanceof Blob) {
    try { const j = JSON.parse(await e.response.data.text()); return typeof j.detail === "string" ? j.detail : "Could not create the PDF"; } catch { /* not json */ }
  }
  return errMsg(e, "Could not create the PDF");
}

export async function pdfAction(mode, method, path, body, shareText) {
  const id = toast.loading("Preparing the PDF…");
  try {
    const { blob, name } = await fetchFile(method, path, body);
    const file = new File([blob], name, { type: "application/pdf" });
    if (mode === "share" && navigator.canShare?.({ files: [file] })) {
      toast.dismiss(id);
      try { await navigator.share({ files: [file], title: name, text: shareText }); } catch (e) { if (e.name !== "AbortError") toast.error("Sharing was cancelled"); }
      return;
    }
    saveBlob(blob, name);
    toast.success(mode === "share" ? "This device can't attach files to WhatsApp directly, so the PDF was downloaded. Attach it in WhatsApp." : "PDF downloaded", { id });
  } catch (e) {
    toast.error(await readError(e), { id });
  }
}

export const openWhatsApp = (text) => window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank", "noopener");
